import { render, staticRenderFns } from "./StocksModal.vue?vue&type=template&id=f79ec22e&scoped=true&"
import script from "./StocksModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StocksModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./StocksModal.vue?vue&type=style&index=0&id=f79ec22e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79ec22e",
  null
  
)

export default component.exports